export default [
    {
        slug: 'male',
        name: 'Мужской'
    },
    {
        slug: 'female',
        name: 'Женский'
    }
]